module.exports = __webpack_public_path__ + "Bitcoin.svg?a83b2040f2facc5d3feea4770c18fcde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/Bitcoin.svg
// module id = 1126
// module chunks = 2